/** @format */

import React from 'react'

import SearchProductAction from './components/SearchProductAction'
import RejectDigital from './components/RejectDigital'
import ActionsButtons from './components/ActionsButtons'

import './style.css'

function actionsValidate(item) {
	if (item.status === 'requested' && item.quotationType !== 'contract') {
		return (
			<>
				<SearchProductAction
					digitalModal={item.digitalModal}
					setDigitalModal={item.setDigitalModal}
					handleAproveOrRejectDigital={item.handleAproveOrRejectDigital}
				/>
				<RejectDigital
					digitalModal={item.digitalModal}
					setDigitalModal={item.setDigitalModal}
					handleAproveOrRejectDigital={item.handleAproveOrRejectDigital}
				/>
			</>
		)
	} else if (item.quotationType === 'contract') {
		return (
			<>
				<ActionsButtons
					action='aprove'
					status={item.status}
					quotationType={item.quotationType}
					newStatus={300}
					title='Completa los campos a continuación'
					dataOrder={{ id: item.id }}
					labelName='Aprobar'
					handleAproveOrReject={item.handleAproveOrReject}
				/>
				<ActionsButtons
					action='reject'
					newStatus={500}
					title='¿Está seguro de que desea rechazar este contra pedido?'
					dataOrder={{ id: item.id }}
					labelName='Rechazar'
					handleAproveOrReject={item.handleAproveOrReject}
					handleAproveOrRejectDigital={item.handleAproveOrRejectDigital}
					danger
				/>
			</>
		)
	} else {
		return (
			<>
				<ActionsButtons
					action='aprove'
					status={item.status}
					quotationType={item.quotationType}
					newStatus={300}
					title='Completa los campos a continuación'
					dataOrder={{ id: item.id }}
					labelName='Aprobar'
					handleAproveOrReject={item.handleAproveOrReject}
				/>
				<ActionsButtons
					action='reject'
					newStatus={500}
					title='¿Está seguro de que desea rechazar este contra pedido?'
					dataOrder={{ id: item.id }}
					labelName='Rechazar'
					handleAproveOrReject={item.handleAproveOrReject}
					handleAproveOrRejectDigital={item.handleAproveOrRejectDigital}
					danger
				/>
			</>
		)
	}
}

export default function AvailableActions(props) {
	return (
		<div className='ph-order-detail-actions-button-container'>
			<div className='ph-order-detail-actions-button-main-container'>
				<h1 className='ph-order-detail-actions-button-title'>Acciones Disponibles</h1>
				<div className='ph-order-detail-actions-button-inner-container'>
					{actionsValidate(props)}
				</div>
			</div>
		</div>
	)
}
